import React, {Component} from 'react';
import {Grid, Hidden} from '@material-ui/core';
import { ChatLista,ChatVentana,GuiaDetallePanel } from '../molecules';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { chatStyles } from '../../styles';
import { getInformacionGuia, getMensajes, readNotifiaciones, permisosNotifiaciones } from '../../redux/ActionCreators';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IGuia } from '../../interface/IGuia';
import { obtenerMensajes, obtenerGuia, obtenerGuiaPorToken} from '../../repository/ChatDao';
import { IMensaje } from '../../interface/IMensaje';
import { mergeMap, map } from 'rxjs/operators';
import { Loader } from '../atoms';
import { permitirNotifiaciones, isMobile } from '../../functions/index';
import { parse } from 'qs';


type ChatState = { open: boolean,cargo:boolean,notificacion:number };
interface ChatProp extends WithStyles<typeof chatStyles> {
    classes:any;
    location:any;
    match:any;
    permiso:boolean;
    nombre:string;
    children?: React.ReactNode;
    className?: string;
    obtenerGuia(guia:IGuia):any;
    obtenerPelos(nombre:string):any;
    obtenerMensajes(mensajes:IMensaje[]):any;
    permitirNotificacion(permitido:boolean):any;
    leerNotificacion(guia:string,numeroNotifiaciones:number):any;
}
class ChatComponent extends Component<ChatProp, ChatState> {
    constructor(props:ChatProp) {
        super(props);
        this.state = {
            open: true,
            cargo: false,
            notificacion: 0
        };
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount(){
        !isMobile() && permitirNotifiaciones().then((result:boolean) => {
            this.props.permitirNotificacion(result);
        }).catch(() => this.props.permitirNotificacion(false));
        
        const token = parse(this.props.location['search'], { ignoreQueryPrefix: true })['at'] as string;
        obtenerGuiaPorToken(token).then((codigo_remision) => {
            console.log("=============p");
            console.log(codigo_remision);
            console.log("=============p");
            obtenerGuia(codigo_remision)
            .pipe(
                mergeMap((guia) => {
                    console.log("XXXXXXXXXXXXXXXXx");
                    console.log(guia);
                    return obtenerMensajes(codigo_remision).pipe(
                        map((mensajes) => {
                            return {
                                guia,
                                mensajes
                            }
                        })
                    )
                })
            )
            .subscribe(obj => {
                console.log(obj);
                this.setState({
                    cargo:true
                })
                this.props.obtenerGuia(obj.guia)
                this.props.obtenerMensajes(obj.mensajes)
                const numeroNotificaciones = obj.mensajes.filter((m) => (m.Isseen?.Cliente===false))
                this.props.leerNotificacion(codigo_remision,numeroNotificaciones.length);
                this.setState({
                    notificacion:numeroNotificaciones.length
                });
                if (this.props.permiso && numeroNotificaciones.length>0){
                    document.title=obj.guia.estado==='FINALIZADO' ? 'Coordinadora' : `(${numeroNotificaciones.length}) Coordinadora`;
                    !isMobile() && new Notification(`Tienes ${numeroNotificaciones.length} mensajes`);
                }else{
                    document.title='Coordinadora';
                }
            })
        }).catch((err) => console.log(err));
    }

    toggleDrawer(){
        this.setState({
            open: !this.state.open
        });
    }
    
    handleOpen(){
        this.setState({open: true})
    }

    handleClose(){
        this.setState({open: false})
    }

    render() {
        const classes = this.props.classes;
        return (
            this.state.cargo ?
            <div className={classes['root']}> 
                <Grid container spacing={1}>
                    <Grid item xs={12} md={3} className={classes['grid-chatlista']}>
                        <ChatLista notificaciones={this.state.notificacion}/>
                    </Grid>
                    <Hidden only={['xs','sm']}>
                        <Grid item xs={12} md={9} className={classes['grid-chatventana']}>
                            <ChatVentana handleClick={this.handleOpen} open={this.state.open}/>
                            <GuiaDetallePanel open={this.state.open} handleClose={this.handleClose}  />
                        </Grid>
                    </Hidden>
                </Grid>
            </div>
            :
            <Loader/>
        );
    }
}

const mapStateToProps = (state:any) => {
    return {
      permiso: state.notificacionPermisosReducer
    }
  }
  
  const mapDispatchToProps = (dispatch: Dispatch) => ({
    obtenerGuia(guia:IGuia){
        dispatch(getInformacionGuia(guia))
    },
    obtenerMensajes(mensajes:IMensaje[]){
        dispatch(getMensajes(mensajes))
    },
    leerNotificacion(guia:string,numeroNotifiaciones:number){
        dispatch(readNotifiaciones(guia,numeroNotifiaciones))
    },
    permitirNotificacion(permitido:boolean){
        dispatch(permisosNotifiaciones(permitido))
    }
})
  

export const Chat = connect(mapStateToProps,mapDispatchToProps)(withStyles(chatStyles)(ChatComponent))